/**
 * Implements the chart bulk import modal.
 */

import GenericModal from "../../generic/modal/base";
import Form from "./form";

const DEFAULTS = {
  // returnRoute: "chart-reviews.bulk-file-imports",
  // returnRouteRefresh: true,
  title: "Bulk Chart Import",
  destroyOnDismiss: false,
};

class BulkImportCharts extends GenericModal {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  onBeforeRender() {
    // call superclass
    if (super.onBeforeRender) super.onBeforeRender();

    this.body.show(new Form());
  }
}

export { BulkImportCharts as default };
